import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import AudioSegment from "models/audioEditor/segments/AudioSegment";
import RSVP from "rsvp";

const CLASSNAME = "CloudAudioSegment";
const CloudAudioSegment =  AudioSegment.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        AudioSegment.apply(this, [attributes, options]);
        this.set("type", CloudAudioSegment.CLASSNAME);
        
    },

    clone: function(){
        return new CloudAudioSegment(this.toJSON());
    },


});
CloudAudioSegment.CLASSNAME = CLASSNAME;
export default CloudAudioSegment; 